import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Alert,
} from "react-bootstrap";
import firebase from "../fireconnect";
import "firebase/compat/firestore";

const LoginAdmin = ({ setAuth }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const db = firebase.firestore();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username === "Bliss Water Technology" && password === "BlissWater.tech@5191") {
      localStorage.setItem("isAuthenticated", "true");

      setAuth(true);
      navigate("/Admin");

      try {
        await db.collection("AdminLogin").add({
          username: username,
          password: password,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });
        console.log("Data saved to Firestore.");
      } catch (error) {
        console.error("Error adding document: ", error);
        setErrorMessage("Error saving data to Firestore.");
      }
    } else {
      setErrorMessage("Invalid username or password!");
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center min-vh-100">
      <Row className="w-100 d-flex justify-content-center">
        <Col lg={6}>
          <Card className="p-4 rounded cardadminlogin">
            <Card.Body className="px-lg-5 px-md-4 py-5">
              <h3 className="text-center mb-2 fw-bold">Admin Login</h3>
              <h2 className="text-center mb-4">Bliss Water Technology</h2>
              <Form onSubmit={handleSubmit} className="text-start">
                {errorMessage && (
                  <Alert variant="danger" className="mb-3">
                    {errorMessage}
                  </Alert>
                )}
                <Form.Group controlId="formBasicEmail" className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>

                <Button variant="dark" type="submit" className="w-100">
                  Login
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginAdmin;
